const DEFAULT_FEATURES = {
  AUTHN_automation_account: 'off'
}

export { DEFAULT_FEATURES }
